module.exports = __webpack_public_path__ + "media/images/ui__arrowRight--dark-0e09c2422e4fcc3fc367db3232cfa0ea.png";